<template>
  <div class="pt-20 pb-28 bg-lightGreenBg">
    <div class="grid-container">
      <div
        class="col-span-4 sm:col-span-6 md:col-span-6 md:col-start-2 lg:col-span-8 lg:col-start-3 text-center"
      >
        <div class="flex justify-center bg-lightGreenBg">
          <div class="mt-12 mb-4">
            <p class="text-3xl font-book text-black text-center">
              {{
                $texts('error.error_searchTitle')
              }}
            </p>
          </div>
        </div>

        <form class="mt-8" @submit.prevent="handleSearch">
          <div class="flex gap-4 relative">
            <input
              v-model="searchQuery"
              type="text"
              placeholder="Suche"
              class="grow caret-lightGreen bg-white text-base md:text-3xl font-regular border-1 border-lightGreen p-5 md:p-10 pr-24 rounded-[30px] md:rounded-full h-18 md:h-28 shadow-[0px_0px_20px_0px_rgba(135,_181,_149,_0.25)] outline-0 focus:border-1 focus:border-lightGreen focus:shadow-[0px_25px_50px_-12px_rgba(0,_0,_0,_0.25)]"
              required
            />
            <button
              type="submit"
              class="absolute right-5 md:right-10 top-5 md:top-10"
            >
              <SpriteSymbol
                name="magnifyingglass"
                alt="Suche"
                class="size-9 text-petrol"
              />
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue'
import { useRouter } from '#imports'

const router = useRouter()
const searchQuery = ref('')

const handleSearch = () => {
  if (!searchQuery.value.trim()) return

  // Navigate to search page with the query parameter
  router.push({
    path: '/suche',
    query: { q: searchQuery.value },
  })
}
</script>
